import CfgDescCfgForm from './CfgDescCfgForm.vue';

export default CfgDescCfgForm;